// extracted by mini-css-extract-plugin
module.exports = {"user_point":"Point_user_point__hWNYJ","trophy_icon":"Point_trophy_icon__2Vf_B"};